import React from 'react';
import { useTranslation } from 'react-i18next';
import OutpaintExpandParamsField from './OutpaintExpandParamsField';
import { DEFAULT_OUTPAINT_EXPAND_PARAMS } from '@/pages/ipe/workbench/constants/imageFissionAspectSize';
import '@/styles/ipe/workbench/Img2ImgPage.css';
import '@/styles/ipe/workbench/AiOutpaintPage.css';

/** 与 AiOutpaintPage 侧栏一致：扩图方式 / 倍数或目标比例 / 输出宽高 */
export default function AiOutpaintStepParams({ p, onChange, readOnly = false }) {
  const { t } = useTranslation('workbench');
  const expandParams = {
    expandMode: p.expandMode ?? DEFAULT_OUTPAINT_EXPAND_PARAMS.expandMode,
    scale: p.scale ?? DEFAULT_OUTPAINT_EXPAND_PARAMS.scale,
    scaleCustom: p.scaleCustom,
    aspectRatio: p.aspectRatio ?? DEFAULT_OUTPAINT_EXPAND_PARAMS.aspectRatio,
    outputWidth: p.outputWidth ?? DEFAULT_OUTPAINT_EXPAND_PARAMS.outputWidth,
    outputHeight: p.outputHeight ?? DEFAULT_OUTPAINT_EXPAND_PARAMS.outputHeight,
  };

  return (
    <div className="img2img-page wf-studio-params-root wf-editor-ai-outpaint ai-outpaint-page">
      <section className="img2img-studio__section outpaint-expand-params-section">
        <span className="img2img-studio__field-label">{t('workflowParams.expandMode')}</span>
        <OutpaintExpandParamsField
          value={expandParams}
          readOnly={readOnly}
          onChange={(patch) => onChange(patch)}
        />
      </section>
      <p className="wf-editor-params__muted wf-editor-fission__footnote">
        {t('workflowParams.expandHint')}
      </p>
    </div>
  );
}
